export const BASE_URL = 'https://api.airtable.com/v0/appKUXvvuGcO6Vj8p';
export const FUNCTION_BASE_URL =
  'https://us-central1-davidvatine.cloudfunctions.net/app';

// export const FUNCTION_BASE_URL = 'http://localhost:3001';

export const API_TOKEN = 'keyS1S94Y0h4r7LEw';
